import httpClient from "./httpClient";

const base = "/online-admission";

// --- Staff side (super-admin) ---
export function applicantList(groupConfigId) {
  return httpClient.get(`${base}/applicants`, { params: { groupConfigId } }).then((res) => res.data.data);
}

export function waitingApplicantList(groupConfigId) {
  return httpClient.get(`${base}/applicants/waiting`, { params: { groupConfigId } }).then((res) => res.data.data);
}

export function admissionApprovedApplicantList(groupConfigId) {
  return httpClient.get(`${base}/applicants/admission-approved`, { params: { groupConfigId } }).then((res) => res.data.data);
}

export function approveForAdmission(applicantIds) {
  return httpClient.post(`${base}/applicants/approve-for-admission`, applicantIds).then((res) => res.data);
}

export function reverseApproveForAdmission(applicantIds) {
  return httpClient.post(`${base}/applicants/reverse-approve-for-admission`, applicantIds).then((res) => res.data);
}

export function approveForWaiting(applicantIds) {
  return httpClient.post(`${base}/applicants/approve-for-waiting`, applicantIds).then((res) => res.data);
}

export function reverseApproveForWaiting(applicantIds) {
  return httpClient.post(`${base}/applicants/reverse-approve-for-waiting`, applicantIds).then((res) => res.data);
}

export function markAsPaid(applicantId) {
  return httpClient.post(`${base}/applicants/${applicantId}/mark-as-paid`).then((res) => res.data);
}

// --- Public side ---
export function saveApplicantInfo(payload) {
  return httpClient.post(`/public/online-admission/apply`, payload).then((res) => res.data);
}

export function findSingleApplicant(registrationId, instituteId) {
  return httpClient
    .get(`/public/online-admission/applicant`, { params: { registrationId, instituteId } })
    .then((res) => res.data.data);
}

export function getFeeInfo(groupConfigId) {
  return httpClient.get(`/public/online-admission/fee-info`, { params: { groupConfigId } }).then((res) => res.data.data);
}

export function uploadApplicantFile(file) {
  const formData = new FormData();
  formData.append("file", file);
  return httpClient
    .post(`/public/online-admission/files`, formData, { headers: { "Content-Type": "multipart/form-data" } })
    .then((res) => res.data.data);
}

export function publicInstituteList() {
  return httpClient.get(`/public/online-admission/institutes`).then((res) => res.data.data);
}

export function publicClassList(instituteId) {
  return httpClient.get(`/public/class/list/by/institute/open-for-admission`, { params: { instituteId } }).then((res) => res.data.data);
}

export function publicGroupConfigList(classId, instituteId) {
  return httpClient
    .get(`/public/group-configurations/by/class-and-institute`, { params: { classId, instituteId } })
    .then((res) => res.data.data);
}
